import { Link } from 'react-router-dom';
import AnimeCard from '@/components/base/AnimeCard';
import { animeList } from '@/mocks/anime';
import { useState } from 'react';

export default function LatestSection() {
  const [activeTab, setActiveTab] = useState<'all' | 'hot' | 'new'>('all');

  const tabs = [
    { id: 'all' as const, label: '全部' },
    { id: 'hot' as const, label: '热门' },
    { id: 'new' as const, label: '新番' },
  ];

  const filtered = animeList.filter((a) => {
    if (activeTab === 'hot') return a.isHot;
    if (activeTab === 'new') return a.isNew;
    return true;
  }).slice(0, 8);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8 md:mb-10">
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">紧跟播出进度，追番不掉队</p>
          </div>
          <div className="flex items-center gap-1 bg-background-200/70 rounded-full p-1 self-start">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'bg-background-50 text-foreground-900'
                    : 'text-foreground-500 hover:text-foreground-700'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {filtered.map((anime) => (
            <AnimeCard key={anime.id} anime={anime} />
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-100 text-secondary-700 rounded-xl text-sm font-medium hover:bg-secondary-200 transition-colors whitespace-nowrap"
          >
            浏览更多番剧
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}